<button type="button" [disabled]="disable" [class.active]="active" (click)="clickEvent($event)">
  <mat-icon>{{ matIcon }}</mat-icon>
  <span>{{ value }}</span>
  <span class="label">{{ label }}</span>
</button>
